import * as St from './SidePanelShapeHeader.styles';

import { useAppSelector } from '~/redux/hooks';
import { selectSelectedColor } from '~/redux/slices/color';
import { selectSelectedMaterial } from '~/redux/slices/material';
import SelectedMaterialColor from '~molecules/SelectedMaterialColor';
import SidePanelShapeHeaderTabs from '~molecules/SidePanelShapeHeaderTabs';

const SidePanelShapeHeader = () => {
  const selectedMaterial = useAppSelector(selectSelectedMaterial);
  const selectedColor = useAppSelector(selectSelectedColor);

  return (
    <St.Container>
      {selectedColor && selectedMaterial ? (
        <SelectedMaterialColor
          selectedColor={selectedColor}
          selectedMaterial={selectedMaterial}
        />
      ) : (
        <div />
      )}
      <SidePanelShapeHeaderTabs />
    </St.Container>
  );
};

export default SidePanelShapeHeader;
